import React, { useEffect, useState } from "react";
import AdminAPI from "../utils/adminApi";

const VendorApplications = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const res = await AdminAPI.get("/vendor-applications");
      setApplications(res.data);
    } catch (err) {
      console.error("❌ Error fetching vendor applications:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (userId) => {
    try {
      await AdminAPI.patch(`/vendor-applications/${userId}/approve`);
      fetchApplications(); // refresh
    } catch (err) {
      console.error("❌ Error approving application:", err);
    }
  };

  const handleReject = async (userId) => {
    const reason = prompt("Enter rejection reason:");
    if (!reason) return;
    try {
      await AdminAPI.patch(`/vendor-applications/${userId}/reject`, { reason });
      fetchApplications();
    } catch (err) {
      console.error("❌ Error rejecting application:", err);
    }
  };

  if (loading) return <p>Loading applications...</p>;

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">📋 Vendor Applications</h2>
      {applications.length === 0 ? (
        <p>No vendor applications yet.</p>
      ) : (
        <div className="space-y-4">
          {applications.map((user) => (
            <div key={user._id} className="border p-4 rounded-lg shadow">
              <h3 className="font-semibold">{user.vendorApplication.fullName}</h3>
              <p>Email: {user.email}</p>
              <p>Phone: {user.vendorApplication.phone}</p>
              <p>Experience: {user.vendorApplication.experience}</p>
              <p>Status: {user.vendorApplication.status}</p>
              {user.vendorApplication.adminNotes && (
                <p className="text-sm text-red-600">
                  Note: {user.vendorApplication.adminNotes}
                </p>
              )}

              {user.vendorApplication.status === "pending" && (
                <div className="mt-3 flex gap-2">
                  <button
                    onClick={() => handleApprove(user._id)}
                    className="px-4 py-2 bg-green-600 text-white rounded-lg"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleReject(user._id)}
                    className="px-4 py-2 bg-red-600 text-white rounded-lg"
                  >
                    Reject
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VendorApplications;
